//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
import { BaseHttpClient } from "./base-http-client";
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class DocumentsClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://orpyx-si-documents-dev-api.azurewebsites.net";
    }
    listDocuments(category, associatedId) {
        let url_ = this.baseUrl + "/Documents/ListAll/{category}/{associatedId}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (associatedId === undefined || associatedId === null)
            throw new Error("The parameter 'associatedId' must be defined.");
        url_ = url_.replace("{associatedId}", encodeURIComponent("" + associatedId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processListDocuments(_response);
        });
    }
    processListDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStatus(documentId) {
        let url_ = this.baseUrl + "/Documents/StatusCheck/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetStatus(_response);
        });
    }
    processGetStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    downloadDocument(documentId) {
        let url_ = this.baseUrl + "/Documents/Download/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDownloadDocument(_response);
        });
    }
    processDownloadDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadDocumentFiles(category, associatedId, files, fileNames) {
        let url_ = this.baseUrl + "/Documents/UploadFiles/{category}/{associatedId}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (associatedId === undefined || associatedId === null)
            throw new Error("The parameter 'associatedId' must be defined.");
        url_ = url_.replace("{associatedId}", encodeURIComponent("" + associatedId));
        url_ = url_.replace(/[?&]$/, "");
        let formData = new FormData();
        files.forEach((x, i) => {
            formData.append('file', x, fileNames[i]);
        });
        let options_ = {
            body: formData,
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUploadDocumentFiles(_response);
        });
    }
    processUploadDocumentFiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadDocument(category, associatedId, description, filename, file) {
        let url_ = this.baseUrl + "/Documents/Upload/{category}/{associatedId}/{description}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (associatedId === undefined || associatedId === null)
            throw new Error("The parameter 'associatedId' must be defined.");
        url_ = url_.replace("{associatedId}", encodeURIComponent("" + associatedId));
        if (description === undefined || description === null)
            throw new Error("The parameter 'description' must be defined.");
        url_ = url_.replace("{description}", encodeURIComponent("" + description));
        url_ = url_.replace(/[?&]$/, "");
        let formData = new FormData();
        formData.append('file', file, filename);
        let options_ = {
            body: formData,
            method: "POST",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUploadDocument(_response);
        });
    }
    processUploadDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    replaceDocumentFile(documentId) {
        let url_ = this.baseUrl + "/Documents/ReplaceFile/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processReplaceDocumentFile(_response);
        });
    }
    processReplaceDocumentFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    replaceDocument(documentId, document) {
        let url_ = this.baseUrl + "/Documents/Replace/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(document);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processReplaceDocument(_response);
        });
    }
    processReplaceDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 201) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateDocument(documentId, request) {
        let url_ = this.baseUrl + "/Documents/Update/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpdateDocument(_response);
        });
    }
    processUpdateDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteDocument(documentId) {
        let url_ = this.baseUrl + "/Documents/Delete/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDeleteDocument(_response);
        });
    }
    processDeleteDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 503) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getVersionInfo() {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {}
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetVersionInfo(_response);
        });
    }
    processGetVersionInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
